module.exports = __webpack_public_path__ + "static/media/background-device.64eefbae.jpg";